import React from "react"
import { useDispatch, useSelector } from "react-redux"
import VehicleDetailsDialog from "components/Templates/VehicleDetailsDialog"
import {
  TOGGLE_VEHICLE_OPEN,
  CHANGE_TAB,
} from "store/all-vehicles/all-vehicles.actions"
import { getId } from "utils/custom.utils"
export default function VehicleDialog({ vehicle }) {
  const vehicleOpen = useSelector(state => state.allVehicles.vehicleOpen.open)
  const tab = useSelector(state => state.allVehicles.vehicleOpen.selectedTab)
  const dispatch = useDispatch()
  return (
    <VehicleDetailsDialog
      selectedTab={tab}
      onTabChange={tab => {
        dispatch({
          type: CHANGE_TAB,
          payload: tab,
        })
      }}
      vehicle={vehicle}
      isOpen={getId(vehicleOpen) === getId(vehicle) ? true : false}
      onClose={e => {
        dispatch({
          type: TOGGLE_VEHICLE_OPEN,
          payload: getId(vehicle),
        })
      }}
    />
  )
}
